<p-popover #op>
  <div class="flex flex-col gap-4 ">
    @if (this.rss.botConfig.isPwProtected) {
    <div>
      <i class="ri-lock-password-fill text-primary"></i>
      <span class="text-muted">
        Passwortschutz Aktiv
      </span>
    </div>
    }
    @if (this.rss.botConfig.enableInstantAccess) {
    <div>
      <i class="ri-check-fill text-primary"></i>
      <span class="text-muted">
        Nutzer Wiedererkennungsoption Aktiv
      </span>
    </div>
    }
  </div>
</p-popover>


<p-drawer
  [(visible)]="showExportPanel"
  appendTo="body"
  header="Share & Export "
  [style]="{width: '40rem'}"
  position="right"
>
  <app-export-drawer-content></app-export-drawer-content>
</p-drawer>
<p-blockui [blocked]="this.loadingService.loading" />
@if (this.loadingService.loading) {
<div
  style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 75%; z-index: 10001; pointer-events: none;"
>
  <p-progressbar
    mode="indeterminate"
    [style]="{'height': '6px'}"
  />
</div>
}
<ng-template
  #menuEntry
  let-item="item"
>
  @if(item.href) {
  <div style="cursor: pointer;">
    <a
      class="nav-link"
      [routerLink]="['/bot-admin', this.rss.botConfig._id, item.href]"
      [routerLinkActive]="'active'"
    >
      <span class="ms-3 fw-bold">
        @if (item.icon) {
        <i
          [ngClass]="'mx-2 ri-xl ' + item.icon"
          style="vertical-align: middle;"
          class="fw-normal"
        ></i>
        }
        {{item.name}}
        @if(item.href === 'blockly' && this.editorItemService.hasDirtyItems()){
        <span class="text-danger fw-normal">
          *
        </span>
        }
      </span>
      @if(item.href === 'documents' && this.counter.getTotalFiles(this.rss.botConfig._id) > 0){
      <div
        class="ms-2"
        tooltip="Aktive / alle Dokumente"
        i18n-tooltip="@@documents-badge-tooltip"
      ><p-tag
          [value]="this.counter.getFiles(this.rss.botConfig._id) + '/' + this.counter.getTotalFiles(this.rss.botConfig._id)"
        />
      </div>
      }
      @if(item.href === 'if-then' && this.counter.getWennDann(this.rss.botConfig._id) > 0){
      <div class="ms-2"><p-tag [value]="'' + this.counter.getWennDann(this.rss.botConfig._id)" />
      </div>
      }
      @if(item.href === 'offline-websites' && this.counter.getOfflineWebsiteCount(this.rss.botConfig._id) > 0){
      <div class="ms-2"><p-tag [value]="'' + this.counter.getOfflineWebsiteCount(this.rss.botConfig._id)" />
      </div>
      }
      @if(item.href === 'databases' && this.counter.getTrunks(this.rss.botConfig._id) > 0){
      <div class="ms-2"><p-tag [value]="'' + this.counter.getTrunks(this.rss.botConfig._id)" />
      </div>
      }
      @if(item.href === 'online-sources' &&this.counter.getTools(this.rss.botConfig._id) > 0){
      <div class="ms-2"><p-tag [value]="'' + this.counter.getTools(this.rss.botConfig._id)" />
      </div>
      }
      @if(item.href === 'webhooks' && this.counter.getWebhooks(this.rss.botConfig._id) > 0){
      <div class="ms-2"><p-tag [value]="'' + this.counter.getWebhooks(this.rss.botConfig._id)" />
      </div>
      }
      @if(item.href === 'mcp-server' && this.counter.getMcps(this.rss.botConfig._id) > 0){
      <div class="ms-2"><p-tag [value]="'' + this.counter.getMcps(this.rss.botConfig._id)" />
      </div>
      }
      @if(item.href === 'supervisor' && this.supervisorService.notificationUnsolvedAll() > 0){
      <div class="ms-2">
        <p-tag
          icon="ri ri-megaphone-fill"
          [value]="'' + this.supervisorService.notificationUnsolvedSummary()"
        />
      </div>
      }
      @if(item.href === 'fusionbot' && this.counter.getFusionView(this.rss.botConfig._id) > 0){
      <div class="ms-2"><p-tag [value]="'' + this.counter.getFusionView(this.rss.botConfig._id)" />
      </div>
      }
      @if(item.href === 'stage-manager' && this.counter.getStageManager(this.rss.botConfig._id) > 0){
      <div class="ms-2"><p-tag [value]="'' + this.counter.getStageManager(this.rss.botConfig._id)" />
      </div>
      }
    </a>
  </div>
  } @else {
  @if(item.addAction) {
  <div class="skills-header">
    <span>{{ item.name }}</span>
    <p-button
      type="button"
      [text]="true"
      size="small"
      icon="ri ri-add-circle-fill ri-lg"
      (onClick)="item.addAction!()"
    />
  </div>
  }
  }
</ng-template>
<ng-template #quickinfo>
  <div
    class="bot-image-wrapper"
    [ngStyle]="{
    'background-color': this.rss.botConfig.hasImage ? 'transparent' : this.rss.botConfig.color,
  }"
  >
    @if (this.rss.botConfig.hasImage) {
    <div
      class="bot-image-blur-bg"
      [ngStyle]="{
        'background-image': 'url(/api/toolbox/membot/public/botimg/'+this.rss.botConfig._id+'/256?t='+this.rss.botImageCacheBuster+')',
      }"
    ></div>
    }
    <div
      class="bot-image-fg"
      [ngStyle]="{
      'color': this.getContrastColor(this.rss.botConfig.color),
      'background-image': this.rss.botConfig.hasImage?  'url(/api/toolbox/membot/public/botimg/'+this.rss.botConfig._id+'/256?t='+this.rss.botImageCacheBuster+')' : '',
      'background-size': 'contain',
      'background-repeat': 'no-repeat',
      'background-position': 'center',
    }"
    >
      <app-bot-admin-card-body-content
        id="adminBodySidebar"
        [botConfig]="this.rss.botConfig"
      >
      </app-bot-admin-card-body-content>
    </div>
  </div>
  @if (!this.rss.botConfig.isDemo && !this.rss.botConfig.isTemplate) {
  }
  @if (this.rss.botConfig.isDemo ) {
  <div
    class="btn btn-outline-primary btn d-block m-2 lock-insensitive mt-3"
    [routerLink]="['/', 'bot-admin', 'demo']"
  >
    <i class="ri-arrow-left-fill"></i>
    <span i18n="@@back-to-components">
      Alle Bausteine im Überblick
    </span>
  </div>
  }
  @if (this.rss.botConfig.isTemplate) {
  <div
    class="btn btn-outline-primary btn d-block m-2 lock-insensitive mt-3"
    [routerLink]="['/', 'bot-admin', 'templates']"
  >
    <i class="ri-arrow-left-fill"></i>
    <span i18n="@@back-to-templates">
      Alle Vorlagen im Überblick
    </span>
  </div>
  }
  @if (this.rss.botConfig.quarantine?.isQuarantined) {
  <div class="alert alert-danger m-2">
    <div class="d-flex justify-content-between align-items-center">
      <div i18n="@@bot-quarantined">Bot ist in Quarantäne</div>
      <button
        class="btn btn-sm btn-outline-danger"
        (click)="this.openQuarantineModal()"
      ><i class="ri-question-mark"></i></button>
    </div>
  </div>
  }
</ng-template>
<ng-template #quarantineModal>
  <div class="modal-header">
    <h3 i18n="@@your-bot-is-quarantined">Dein Bot befindet sich in Quarantäne</h3>
  </div>
  @if (this.rss.botConfig.quarantine?.isQuarantined) {
  <div class="modal-body">
    <div
      class="alert alert-primary"
      i18n="@@quarantine-explanation"
    >Die Quarantäne ist eine Schutzmaßnahme, um ungewollte Kosten durch eine sehr große
      Anzahl an Anfragen zu vermeiden. Solange der Bot in Quarantäne ist, werden alle Anfragen, welche kosten erzeugen
      können, abgebrochen.</div>
    <p>
      <b i18n="@@when-did-it-happen">Wann ist das passiert?</b><br><span>
        {{this.rss.botConfig.quarantine.quarantinedAt | date: 'dd.MM.yyyy HH:mm:ss'}}
      </span>
    </p>
    <p>
      <b i18n="@@why-did-it-happen">Warum ist das passiert?</b><br><span>
        <span>
          @switch (this.rss.botConfig.quarantine.quarantineType) {
          @case ('response') {
          <span i18n="@@too-many-responses">
            Es wurden in kurzer Zeit zu viele Chat-Nachrichten an den Bot gesendet.
          </span>
          }
          @case ('chatcompletion') {
          <span i18n="@@too-many-chatcompletions">
            Es wurden in kurzer Zeit zu viele ChatCompletions ausgeführt.
          </span>
          }
          @default {
          <span>
            Unbekannter Grund: {{this.rss.botConfig.quarantine.quarantineType}}
          </span>
          }
          }
        </span>
      </span>
    </p>
    <p>
      <b i18n="@@addional">Zusatz:</b><br>{{this.rss.botConfig.quarantine.message}}
    </p>
  </div>
  }
  <div class="modal-footer justify-content-start">
    <div class="flex-grow-1">
      <div
        class="alert alert-danger mb-0"
        i18n="@@quarantined-accept-risk-disclaimer"
      >
        Durch die Aufhebung der Quarantäne können weitere Kosten entstehen.
        Überprüfe zuerst deinen Logik-Editor nach ungewollten Aufrufen.
      </div>
    </div>
    <div class="d-flex align-items-center flex-grow-1 justify-content-between">
      <div>
        <div>
          <input
            id="acceptRisk"
            type="checkbox"
            [(ngModel)]="this.acceptQuarantineRisk"
            class="me-2"
          > <label
            for="acceptRisk"
            i18n="@@quarantined-accept-risk"
          >Ich habe den Hinweis gelesen und bin mit dem Risiko einverstanden.</label>
        </div>
        <div>
          <input
            id="skipQuarantineToday"
            type="checkbox"
            [(ngModel)]="this.skipQuarantineToday"
            class="me-2"
          > <label
            for="skipQuarantineToday"
            i18n="@@skip-quarantine-today"
          >Quarantäne-Überprüfung für Heute deaktivieren.</label>
        </div>
      </div>
      <div>
        <button
          class="btn btn-danger"
          [disabled]="!this.acceptQuarantineRisk"
          (click)="this.releaseFromQuarantine()"
          i18n="@@remove-from-quarantine"
        >Quarantäne aufheben</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #pageHeader>

  <app-page-header-over-editor></app-page-header-over-editor>
</ng-template>
<rag-body-layout
  [contentHeaderTpl]="pageHeader"
  [classList]="this.rss.userCanEditBotConfig() ? [''] : this.isInsightsRoute() ? ['bot-locked-insights'] : ['bot-locked-for-user']"
  [sidebarHeaderTpl]="quickinfo"
  [navItems]="this.navItems"
>

  <app-provider-status provider="openai"></app-provider-status>
  <app-provider-status provider="elevenlabs"></app-provider-status>
  <app-provider-status provider="did"></app-provider-status>
  <app-provider-status provider="heygen"></app-provider-status>
  <app-provider-status provider="liveavatar"></app-provider-status>
  <app-provider-status provider="falai"></app-provider-status>
  <router-outlet></router-outlet>
  @for (item of this.helpUrls; track item ; let i = $index) {
  <app-chatbot-embed
    [botId]="this.botIdFromItem(item, i)"
    [botName]="this.nameFromItem(item)"
    [chatbotUrl]="this.urlFromItem(item)"
    [scriptSrc]="this.embedScriptSrc"
  ></app-chatbot-embed>
  }

</rag-body-layout>

<app-skill-create-dialog [(visible)]="showSkillCreateDialog"></app-skill-create-dialog>